import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form'
import { Flex, Heading, FormErrorMessage,  FormLabel,  FormControl,  Input,  Button, Box, Stack, Text } from '@chakra-ui/react';
import FieldItem from '../FieldItem';

type Props = {
  list: any[];
  onFieldsUpdate: (list: any[]) => void;
};

function Fields({ list, onFieldsUpdate }: Props) {
  const [listLocal, setListLocal] = useState(list);

  useEffect(() => {
    onFieldsUpdate(listLocal);
  }, [listLocal])

  const addField = () => {		
    setListLocal([
      ...listLocal,
      {
        type: "text",
        key: "",
        label: "",
        placeholder: "",
        defaultValue: "",
        showLabel: "true",
        required: "true",
        validation: "",
        options: "",
        style: {
          width: "100%"
        }
      },
    ])
  }

  const onFieldUpdate = (item:any, index:number) => {		
    let listLocalCopy = [...listLocal];
    listLocalCopy[index] = item;
    setListLocal(listLocalCopy);
  }

  return (
    <>
    <Heading size="sm" pb="1" color="b.gr">필드</Heading>
    <Text pb="3" fontSize="xs">비로그인 유저 확인을 위해 이름(name)과 이메일(email)은 필수입니다.</Text>
    <Stack>
      {
        listLocal.map((item:any, index:number) => (
          <FieldItem item={item} key={index} index={index} onFieldUpdate={onFieldUpdate} />
        ))
      }
    </Stack>
    <Box textAlign="right" pt="6">
      <Button variant='outline' size="sm" colorScheme="g" type='button' onClick={addField}> 
        필드 추가
      </Button>
    </Box>
    </>
  );
}

Fields.defaultProps = {
};

export default Fields;